import React, { FC } from 'react';

import styles from './HelperReason.module.scss';

const CompanyPublicForAdminReason: FC = () => {
  return (
    <div className={styles.dialog_inner}>
      <div className={styles.inner_texts}>
        下記項目を完了すると、登録が完了し会社紹介ページが公開されます。
        <div className={styles.divider} />
        <li>
          <span>会社概要の必須項目</span>が登録されていること。
        </li>
        <li>
          <span>タグ</span>が１つ以上登録されていること。
        </li>
        <li>
          <span>紹介写真</span>が２枚以上承認されていること
        </li>
        <li>
          <span>承認済の売却実績</span>が１件以上登録されていること。
        </li>
        <li>
          <span>アピールポイント</span>の登録が完了していること。
        </li>
        <li>
          <span>会社紹介タイトル１</span>の登録が完了していること。
        </li>
        <li>
          <span>会社紹介文１</span>の登録が完了していること。
        </li>
      </div>
    </div>
  );
};

export default CompanyPublicForAdminReason;
